import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { Loader } from "@/components/cast/Common";
import { StoryPlayer } from "@/components/cast/StoryPlayer";

export default function Episode() {
  const { episodeId } = useParams();
  const [ep, setEp] = useState<any>(null);
  useEffect(() => { setEp(null); api.get(`/episodes/${episodeId}`).then((r) => setEp(r.data)); }, [episodeId]);
  if (!ep) return <Loader />;
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <Link to={`/boat/${ep.series.id}`} data-testid="episode-back-link" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-slate-900"><ChevronLeft className="h-4 w-4" />{ep.series.title}</Link>
      <div>
        <p className="eyebrow">Episode {ep.order} · {ep.ref}</p>
        <h1 className="mt-2 font-display text-4xl font-semibold text-slate-900 sm:text-5xl" data-testid="episode-title">{ep.title}</h1>
      </div>
      <StoryPlayer episode={ep} base="/episode/" onComplete={async (r) => (await api.post("/progress", { episode_id: ep.id, quiz_score: r.score, quiz_total: r.total, choices: r.choices })).data} />
    </div>
  );
}
